import { useEffect, useState } from "react";
import { getDaysBeforeStart, getRemainingDays } from "../utils/date";

const useCountDown = ({ challenge }) => {
    const [days, setDays] = useState("");
    const [remaining, setRemaining] = useState(null);
    useEffect(() => {
        let daysTmp = 0;
        let rem = getRemainingDays(challenge?.enddate)
        if (new Date(challenge?.startdate) <= new Date()) {
            daysTmp = `${rem} days remaining`;

        } else {
            daysTmp = `Starts in ${getDaysBeforeStart(challenge?.startdate)} days`;
        }

        setDays(daysTmp);
        setRemaining(rem);
    }, [challenge]);

    return { days, remaining };
}

export default useCountDown;
